import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useMemo, useState } from 'react';
import { defaultCountries, parseCountry, FlagImage } from 'react-international-phone';
import 'react-international-phone/style.css';
const PhoneInput = ({ value, country, onValueChange, onCountryChange, error, disabled = false, required = false, fullWidth = true, size = 'small', label, placeholder, primaryColor = '#26890D', borderColor = '#9E9E9E' }) => {
    const [countrySearchTerm, setCountrySearchTerm] = useState('');
    const filteredCountries = useMemo(() => {
        if (!countrySearchTerm.trim())
            return defaultCountries;
        const searchLower = countrySearchTerm.toLowerCase();
        return defaultCountries.filter((c) => {
            const parsed = parseCountry(c);
            return (parsed.name.toLowerCase().includes(searchLower) ||
                parsed.dialCode.includes(searchLower) ||
                parsed.iso2.toLowerCase().includes(searchLower));
        });
    }, [countrySearchTerm]);
    const handleValueChange = (e) => {
        const digits = e.target.value.replaceAll(/\D/g, '');
        onValueChange(digits);
    };
    const handleCountryChange = (e) => {
        onCountryChange(e.target.value);
    };
    return (_jsx(TextField, { fullWidth: fullWidth, size: size, label: label, required: required, value: value, onChange: handleValueChange, disabled: disabled, error: !!error, helperText: error, placeholder: placeholder, slotProps: {
            input: {
                startAdornment: (_jsx(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '8px',
                        height: '100%'
                    }, children: _jsx(FormControl, { children: _jsxs(Select, { size: "small", value: country, onChange: handleCountryChange, disabled: disabled, variant: "standard", disableUnderline: true, IconComponent: () => null, onOpen: () => setCountrySearchTerm(''), MenuProps: {
                                disablePortal: true,
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                PaperProps: {
                                    sx: {
                                        maxHeight: '300px',
                                        marginTop: '6px',
                                        '& .MuiList-root': {
                                            paddingTop: 0
                                        }
                                    }
                                }
                            }, sx: {
                                minWidth: 'auto',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '& .MuiSelect-select': {
                                    paddingRight: '0px !important',
                                    paddingLeft: '0px !important',
                                    paddingTop: '0px !important',
                                    paddingBottom: '0px !important',
                                    display: 'flex !important',
                                    alignItems: 'center !important',
                                    justifyContent: 'center !important',
                                    gap: '4px',
                                    height: '100%',
                                    margin: '0 auto',
                                    width: '100%'
                                },
                                '& .MuiInputBase-root': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }
                            }, renderValue: (val) => {
                                const c = defaultCountries.find((d) => d[1] === val);
                                if (!c)
                                    return null;
                                const parsed = parseCountry(c);
                                return (_jsxs(Box, { sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        height: '20px',
                                        lineHeight: '20px'
                                    }, children: [_jsxs(Box, { sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '2px 4px',
                                                borderRadius: '4px',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(33, 33, 33, 0.08)'
                                                }
                                            }, children: [_jsx(FlagImage, { iso2: parsed.iso2, style: {
                                                        width: '24px',
                                                        height: '18px',
                                                        display: 'block'
                                                    } }), _jsx(ArrowDropDownIcon, { sx: {
                                                        fontSize: '20px',
                                                        color: '#666',
                                                        marginLeft: '-2px',
                                                        display: 'block'
                                                    } })] }), _jsx(Box, { sx: {
                                                width: '1px',
                                                height: '16px',
                                                backgroundColor: borderColor,
                                                opacity: 0.5
                                            } }), _jsxs(Box, { sx: {
                                                fontSize: '16px',
                                                color: '#666',
                                                fontWeight: 400,
                                                lineHeight: '28px',
                                                marginLeft: '6px'
                                            }, children: ["+", parsed.dialCode] })] }));
                            }, children: [_jsx(Box, { sx: {
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#fff',
                                        zIndex: 1,
                                        padding: '12px 16px',
                                        borderBottom: `1px solid #EBEBEB`
                                    }, onKeyDown: (e) => e.stopPropagation(), children: _jsx(TextField, { size: "small", fullWidth: true, placeholder: "Search", value: countrySearchTerm, onChange: (e) => setCountrySearchTerm(e.target.value), onClick: (e) => e.stopPropagation(), autoFocus: true, slotProps: {
                                            input: {
                                                startAdornment: (_jsx(Box, { component: "span", sx: {
                                                        marginRight: '8px',
                                                        color: '#666',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        fontSize: '18px'
                                                    }, children: _jsx(SearchIcon, { sx: { fontSize: '20px' } }) }))
                                            }
                                        }, sx: {
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#F5F5F5',
                                                borderRadius: '8px',
                                                '& fieldset': { border: 'none' },
                                                '&:hover fieldset': {
                                                    border: 'none'
                                                },
                                                '&.Mui-focused': {
                                                    backgroundColor: '#F5F5F5',
                                                    '& fieldset': { border: 'none' }
                                                }
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '10px 12px',
                                                fontSize: '14px',
                                                fontFamily: 'Open Sans',
                                                '&::placeholder': {
                                                    color: '#666',
                                                    opacity: 0.7
                                                }
                                            }
                                        } }) }), filteredCountries.length === 0 ? (_jsx(MenuItem, { disabled: true, children: _jsx(Box, { sx: {
                                            fontSize: '14px',
                                            color: '#666',
                                            textAlign: 'center',
                                            width: '100%'
                                        }, children: "No countries found" }) })) : (filteredCountries.map((c) => {
                                    const parsed = parseCountry(c);
                                    return (_jsx(MenuItem, { value: parsed.iso2, children: _jsxs(Box, { sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }, children: [_jsx(FlagImage, { iso2: parsed.iso2, style: {
                                                        width: '20px',
                                                        height: '15px'
                                                    } }), _jsxs(Box, { sx: { fontSize: '14px' }, children: [parsed.name, " (+", parsed.dialCode, ")"] })] }) }, parsed.iso2));
                                }))] }) }) }))
            }
        }, sx: {
            '& .MuiOutlinedInput-root': {
                borderRadius: '4px',
                '& fieldset': { borderColor },
                '&:hover fieldset': { borderColor },
                '&.Mui-focused fieldset': {
                    borderColor: primaryColor,
                    borderWidth: '1px'
                },
                '&.Mui-error fieldset': {
                    borderColor: '#d32f2f'
                }
            },
            '& .MuiFormHelperText-root': {
                fontFamily: 'Open Sans',
                fontSize: '12px',
                lineHeight: '128%',
                marginLeft: 0,
                marginTop: '4px'
            },
            '& .MuiInputLabel-asterisk': {
                color: '#d32f2f'
            }
        } }));
};
export default PhoneInput;
